<div
  class="profile-container"
  [ngClass]="{
    'max-w-profile': context === 'profile',
    'max-w-default': context === 'default',
  }"
>
  <h2 *ngIf="context !== 'profile'" class="section-title">Personal Info</h2>

  <div class="spinner" *ngIf="loading"></div>

  <div *ngIf="!loading" class="w-100">
    <div class="profile-image-section">
      <div class="profile-image-wrapper">
        <div class="profile-image-container" *ngIf="isAdminOrTeacher">
          <img
            [src]="displayedProfileImage"
            alt="Profile"
            class="profile-image"
          />

          <div class="profile-overlay">
            <button
              type="button"
              class="profile-btn"
              (click)="uploadNewPicture()"
              [disabled]="context === 'profile' && !isEditMode"
              title="Upload Picture"
            >
              <img
                src="assets/images/camera.svg"
                alt="Upload"
                class="btn-icon"
              />
            </button>
            <button
              type="button"
              class="profile-btn"
              (click)="deleteProfilePicture()"
              [disabled]="context === 'profile' && !isEditMode"
              title="Delete Picture"
            >
              <img
                src="assets/images/trash.svg"
                alt="Delete"
                class="btn-icon"
              />
            </button>
          </div>
        </div>
        <div class="profile-image-container" *ngIf="isStudent">
          <div class="profile-image-student">
            <div>{{ displayInitials }}</div>
          </div>
        </div>

        <div class="user-info">
          <div class="user-name">{{ displayName }}</div>
          <div class="user-role">{{ displayRole }}</div>
        </div>

        <div *ngIf="userRoles.manage.edit">
          <div class="edit-button" (click)="enableEdit()">
            <svg
              width="24"
              height="24"
              viewBox="0 0 24 24"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
            >
              <path
                xmlns="http://www.w3.org/2000/svg"
                d="M16.19 2H7.81C4.17 2 2 4.17 2 7.81V16.18C2 19.83 4.17 22 7.81 22H16.18C19.82 22 21.99 19.83 21.99 16.19V7.81C22 4.17 19.83 2 16.19 2ZM10.95 17.51C10.66 17.8 10.11 18.08 9.71 18.14L7.25 18.49C7.16 18.5 7.07 18.51 6.98 18.51C6.57 18.51 6.19 18.37 5.92 18.1C5.59 17.77 5.45 17.29 5.53 16.76L5.88 14.3C5.94 13.89 6.21 13.35 6.51 13.06L10.97 8.6C11.05 8.81 11.13 9.02 11.24 9.26C11.34 9.47 11.45 9.69 11.57 9.89C11.67 10.06 11.78 10.22 11.87 10.34C11.98 10.51 12.11 10.67 12.19 10.76C12.24 10.83 12.28 10.88 12.3 10.9C12.55 11.2 12.84 11.48 13.09 11.69C13.16 11.76 13.2 11.8 13.22 11.81C13.37 11.93 13.52 12.05 13.65 12.14C13.81 12.26 13.97 12.37 14.14 12.46C14.34 12.58 14.56 12.69 14.78 12.8C15.01 12.9 15.22 12.99 15.43 13.06L10.95 17.51ZM17.37 11.09L16.45 12.02C16.39 12.08 16.31 12.11 16.23 12.11C16.2 12.11 16.16 12.11 16.14 12.1C14.11 11.52 12.49 9.9 11.91 7.87C11.88 7.76 11.91 7.64 11.99 7.57L12.92 6.64C14.44 5.12 15.89 5.15 17.38 6.64C18.14 7.4 18.51 8.13 18.51 8.89C18.5 9.61 18.13 10.33 17.37 11.09Z"
                fill="#007BFF"
                class="__web-inspector-hide-shortcut__"
              />
            </svg>
          </div>
        </div>
      </div>
    </div>

    <input
      #fileInput
      type="file"
      id="profile-image-input"
      accept="image/png, image/jpeg"
      (change)="onFileSelected($event)"
      style="display: none"
    />

    <div class="border-bottom"></div>

    <div class="personal-info">Personal Info</div>

    <!-- Admin/Teacher Form -->
    <form
      [formGroup]="profileForm"
      class="profile-form d-grid gap-14"
      *ngIf="isAdminOrTeacher"
    >
      <div [ngClass]="{ 'profile-card': context === 'profile' }">
        <app-input
          context="Normal"
          class="form-item"
          label="First name"
          placeholder="Enter your first name"
          type="text"
          [control]="profileForm.get('firstName')"
          [required]="true"
          [customErrorMessages]="customErrorMessages.firstName"
          [disabled]="!isControlEnabled('firstName')"
        >
        </app-input>

        <app-input
          context="Normal"
          class="form-item"
          label="Last name"
          placeholder="Enter your last name"
          type="text"
          [control]="profileForm.get('lastName')"
          [required]="true"
          [customErrorMessages]="customErrorMessages.lastName"
          [disabled]="!isControlEnabled('lastName')"
        >
        </app-input>
      </div>

      <div
        [ngClass]="{ 'profile-card': context === 'profile' }"
        class="d-grid gap-14"
      >
        <app-input
          context="Normal"
          class="form-item"
          label="Primary Email"
          placeholder="Enter your email"
          type="email"
          [control]="profileForm.get('email')"
          [customErrorMessages]="customErrorMessages.email"
          [disabled]="true"
        >
        </app-input>
        <div *ngIf="this.Role !== 'csquser'">
          <app-input
            context="Normal"
            class="form-item"
            label="Secondary Email"
            placeholder="Enter your email"
            type="email"
            [control]="profileForm.get('secondaryemail')"
            [customErrorMessages]="customErrorMessages.secondaryemail"
            [disabled]="!isControlEnabled('secondaryemail')"
          >
          </app-input>
        </div>

        <app-input
          context="Normal"
          class="form-item"
          label="Phone Number"
          placeholder="Enter your phone number"
          type="tel"
          [control]="profileForm.get('mobileNumber')"
          [customErrorMessages]="customErrorMessages.mobileNumber"
          [required]="false"
          [disabled]="!isControlEnabled('mobileNumber')"
        >
        </app-input>

        <!-- <div *ngIf="this.Role !== 'csqadmin'"> -->
        <div
          *ngIf="
            Role !== 'csqadmin' && Role !== 'superadmin' && Role !== 'csquser'
          "
        >
          <app-input
            context="Normal"
            class="form-item"
            label="School"
            placeholder="Enter your school name"
            type="text"
            [control]="profileForm.get('schoolName')"
            [customErrorMessages]="customErrorMessages.schoolName"
            [disabled]="true"
          >
          </app-input>
        </div>
      </div>

      <!-- Form Actions -->
      <div class="form-actions" *ngIf="context !== 'profile' || isEditMode">
        <button type="button" class="btn-cancel" (click)="onCancel()">
          Cancel
        </button>
        <button type="button" class="btn-save" (click)="onSave()">
          {{ isSubmitting ? "Saving..." : "Save" }}
        </button>
      </div>
    </form>

    <!-- Student Form -->
    <form
      [formGroup]="studentForm"
      class="profile-form d-grid gap-14"
      *ngIf="isStudent"
    >
      <div [ngClass]="{ 'profile-card': context === 'profile' }">
        <app-input
          context="Normal"
          class="form-item"
          label="First name"
          placeholder="Enter your first name"
          type="text"
          [control]="studentForm.get('firstName')"
          [customErrorMessages]="customErrorMessages.firstName"
          [disabled]="true"
        >
        </app-input>

        <app-input
          context="Normal"
          class="form-item"
          label="Last name"
          placeholder="Enter your last name"
          type="text"
          [control]="studentForm.get('lastName')"
          [customErrorMessages]="customErrorMessages.lastName"
          [disabled]="true"
        >
        </app-input>
      </div>

      <div
        [ngClass]="{ 'profile-card': context === 'profile' }"
        class="d-grid gap-14"
      >
        <app-input
          context="Normal"
          class="form-item"
          label="Email (School)"
          placeholder="Enter your school email"
          type="email"
          [control]="studentForm.get('schoolEmail')"
          [customErrorMessages]="customErrorMessages.schoolEmail"
          [disabled]="true"
        >
        </app-input>

        <app-input
          context="Normal"
          class="form-item"
          label="Email (personal)"
          placeholder="Enter your personal email"
          type="email"
          [control]="studentForm.get('secondaryemail')"
          [customErrorMessages]="customErrorMessages.secondaryemail"
          [disabled]="!isControlEnabled('secondaryemail')"
        >
        </app-input>

        <app-input
          context="Normal"
          class="form-item"
          label="Mobile number"
          placeholder="Enter your mobile number"
          type="email"
          [control]="studentForm.get('mobileNumber')"
          [customErrorMessages]="customErrorMessages.mobileNumber"
          [disabled]="true"
        >
        </app-input>

        <app-input
          context="Normal"
          class="form-item"
          label="School"
          placeholder="Enter your school name"
          type="email"
          [control]="studentForm.get('schoolName')"
          [customErrorMessages]="customErrorMessages.schoolName"
          [disabled]="true"
        >
        </app-input>

        <app-input
          context="Normal"
          class="form-item"
          label="Date of Birth"
          placeholder="Enter your date of birth"
          type="date"
          [dateType]="true"
          [control]="studentForm.get('dateOfBirth')"
          [customErrorMessages]="customErrorMessages.dateOfBirth"
          [disabled]="true"
        >
        </app-input>

        <app-input
          context="Normal"
          class="form-item"
          label="Year level/Grade"
          placeholder="Enter your year level"
          type="select"
          [options]="yearLevelOption"
          [control]="studentForm.get('yearLevel')"
          [customErrorMessages]="customErrorMessages.yearLevel"
           [disabled]="true"
        >
        </app-input>

        <app-input
          context="Normal"
          class="form-item"
          label="Parent/Guardian full name"
          placeholder="Enter parent/guardian full name"
          type="text"
          [control]="studentForm.get('parentGuardianFullName')"
          [customErrorMessages]="customErrorMessages.parentGuardianFullName"
          [disabled]="true"
        >
        </app-input>

        <app-input
          context="Normal"
          class="form-item"
          label="Parent/Guardian email"
          placeholder="Enter parent/guardian email"
          type="email"
          [control]="studentForm.get('parentEmail')"
          [customErrorMessages]="customErrorMessages.parentEmail"
          [disabled]="true"
        >
        </app-input>

        <app-input
          context="Normal"
          class="form-item"
          placeholder="Select your gender"
          label="Gender"
          [optional]="true"
          type="select"
          [control]="studentForm.get('gender')"
          [options]="genderOptions"
        ></app-input>

        <app-input
          context="Normal"
          class="form-item"
          label="Ethnicity"
          placeholder="Enter ethnicity"
          type="select"
          [control]="studentForm.get('ethnicity')"
          [customErrorMessages]="customErrorMessages.ethnicity"
           [disabled]="true"
          [options]="ethnicityOption"
        >
        </app-input>
      </div>

      <div class="d-grid gap-3" *ngIf="isStudent">
        <div class="question-grid" [class.disabled]="true">
          <div class="primary-text">
            1. In the past 12 months, have you (or the student) been enrolled in any construction-related course at any level (e.g., school, vocational training, or tertiary education)?
          </div>
          <div>
            <app-input
              context="Normal"
              class="form-item"
              placeholder="Select"
              [optional]="true"
              type="select"
              [control]="studentForm.get('constructionCourse')"
              [options]="dataOption"
              [disabled]="true"
            ></app-input>
          </div>
        </div>

        <div class="checkbox-grid" *ngIf="showConstructionCourseAnswers">
          <div
            *ngFor="let area of constructionPastAnswers"
            class="checkbox-wrapper"
           [class.disabled]="true"
          >
            <label class="custom-checkbox">
              <input
                type="checkbox"
                [value]="area.id"
                (change)="onSelectChange($event, 1)"
                [checked]="isCourseChecked('past', area.id)"
                [disabled]="!isControlEnabled('constructionCourse')"
              />
              <span class="checkmark"></span>
              <span class="form-label2">{{ area.courseName }}</span>
            </label>
          </div>
        </div>

        <div class="question-grid" [class.disabled]="true">
          <div class="primary-text">
            2. Are you (or the student) currently enrolled in, or have you (they) previously completed, any construction-related courses?
          </div>
          <div>
            <app-input
              context="Normal"
              class="form-item"
              placeholder="Select"
              [optional]="true"
              type="select"
              [control]="studentForm.get('constructionRelatedCourse')"
              [options]="dataOption"
            [disabled]="true"
            ></app-input>
          </div>
        </div>

        <div class="checkbox-grid" *ngIf="showConstructionRelatedCourseAnswers">
          <div
            *ngFor="let area of constructionCompAnswers"
            class="checkbox-wrapper"
           [class.disabled]="true"
          >
            <label class="custom-checkbox">
              <input
                type="checkbox"
                [value]="area.id"
                (change)="onSelectChange($event, 2)"
                [checked]="isCourseChecked('comp', area.id)"
                [disabled]="!isControlEnabled('constructionRelatedCourse')"
              />
              <span class="checkmark"></span>
              <span class="form-label2">{{ area.courseName }}</span>
            </label>
          </div>
        </div>
      </div>
      <!-- Form Actions -->
      <div class="form-actions" *ngIf="context !== 'profile' || isEditMode">
        <button type="button" class="btn-cancel" (click)="onCancel()">
          Cancel
        </button>
        <button
          type="button"
          class="btn-save"
          (click)="onSave()"
          [class.disabled]="isSubmitting"
        >
          {{ isSubmitting ? "Saving..." : "Save" }}
        </button>
      </div>
    </form>
  </div>
</div>
